<template>
  <div>
    <configLabel
      v-if="field === 'configLabel'"
      :id="id"
      :category="category"
      :value="value"
    />
    <templateName
      v-if="field === 'templateName'"
      :id="id"
      :category="category"
      :value="value"
      :isTemplate="isTemplate"
    />
    <templateId
      v-if="field === 'clientId'"
      :id="id"
      :category="category"
      :value="value"
      :isTemplate="isTemplate"
    />
    <logo
      v-if="field === 'logo'"
      :id="id"
      :category="category"
      :readOnly="readOnly"
    />
  </div>
</template>
  
<script>
/**
 * @fileoverview Custom fields handler
 *
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

import configLabel from "./configLabel";
import templateName from "./templateName";
import templateId from "./templateId";
import logo from "./logo";

export default {
  name: "CustomFields",
  components: {
    configLabel,
    templateName,
    templateId,
    logo,
  },
  props: {
    id: {
      type: String,
    },
    category: {
      type: String,
    },
    field: {
      type: String,
    },
    value: {
      type: [String, Object, Number, Boolean, Array],
      default: "",
    },
    isTemplate: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
  
<style lang="scss" scoped>
</style>